export const getFileBlob = async (fileUrl: string): Promise<Blob> => {
    const response = await fetch(fileUrl);
    if (!response.ok) {
        throw new Error('Failed to fetch file blob');
    }
    const blob = await response.blob();
    return blob;
};

export const prepareBlobFile = async (file: Blob): Promise<Blob> => {
    const pdfBlob = new Blob([file], { type: 'application/pdf' });
    return pdfBlob;
};

export const convertBlobToBase64 = async (file: Blob): Promise<string> => {
    const pdfBlob = new Blob([file], { type: 'application/pdf' });
    const pdfBase64 = await new Promise<string>((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(pdfBlob);
        reader.onload = () => resolve(reader.result as string);
        reader.onerror = (error) => reject(error);
    });

    return pdfBase64;
};
